__turbopack_context__.v({
  "actionIcon": "menu-drawer-module__Dl6BNq__actionIcon",
  "infoEmail": "menu-drawer-module__Dl6BNq__infoEmail",
  "infoName": "menu-drawer-module__Dl6BNq__infoName",
  "linkWrapper": "menu-drawer-module__Dl6BNq__linkWrapper",
  "menuButton": "menu-drawer-module__Dl6BNq__menuButton",
  "menuDrawer": "menu-drawer-module__Dl6BNq__menuDrawer",
  "menuIcon": "menu-drawer-module__Dl6BNq__menuIcon",
  "menuList": "menu-drawer-module__Dl6BNq__menuList",
  "topContent": "menu-drawer-module__Dl6BNq__topContent",
  "topContentInfo": "menu-drawer-module__Dl6BNq__topContentInfo",
  "wrapper": "menu-drawer-module__Dl6BNq__wrapper",
});
